<template>
    <div>
        <div v-if="!saved">
            <div class="form-group">
                <label class="control-label">Company</label>
                <company :create="true" v-model="model.company" :min-length="0"></company>
            </div>
            <p class="instruct-sm">Company field is optional</p>

            <txt label="Site Name" v-model="model.site_name"></txt>
            <p class="instruct-sm">Name your wesbite eg. "John's Blog"</p>

            <txt label="domain" v-model="model.domain"></txt>
            <p class="instruct-sm">eg. "johnsblog.com"</p>


            <div class="form-group">
                <label class="control-label">Group</label>

                <select class="form-control" v-model="model.group">
                    <option value="Complète" selected>Complete</option>
                    <option value="Cloud">Cloud</option>
                    <option value="MY7">MY7</option>
                    <option value="Ungrouped">Ungrouped</option>
                </select>
            </div>

            <div class="alert alert-danger" v-if="error">{{ error }}</div>

            <div class="buttons">

                <button @click.prevent="store" type="submit" class="btn btn-success btn-sm" :disabled="submitting">
                    <span v-if="!submitting"><i class="icon icon-tick"></i> Add Site</span>
                    <span v-if="submitting"><i class="icon icon-spinner fa-spin"></i> saving...</span>
                </button>
            </div>
        </div>
        <div v-else id="websiteSaving">
            <div id="savedLinks">
                <span>Your WP Remote website has been added. <br>
                    What do you want to do next?</span><br><br>
                Api Key: <span v-html="websiteDetails.api_key"></span>
                <br><br>
                <a :href="websiteDetails.site_url" target="_blank" class="btn btn-primary">Visit Website</a>
                <a :href="websiteDetails.admin_url" target="_blank" class="btn btn-primary">Website Admin</a>
                <!-- Company -->
                <a v-show="model.company.id" :href="companyLink(model.company)" class="btn btn-primary">{{ model.company.name }}</a>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            name: { default: '' },
        },
        components: {
            'company': require('../../components/autocomplete/company.vue').default,
        },
        data() {
            return {
                websiteDetails: false,
                saved: false,
                error: false,
                submitting: false,
                nonce: '',
                model: {
                    site_name: '',
                    company: {
                        id: 0,
                        name: ''
                    },
                    domain: ''
                }
            }
        },
        created() {
            this.axios.get('/wpremote/api/json/account/maekit/nonce').then((response) => {
                this.nonce = response.data;
            });
//            this.$eventHub.$on('saving' + this.name, this.savingWebsite);
        },
        watch: {
            'model.domain': function (val) {
                this.model.domain = val.replace('http://','').replace('https://', '').replace('www.', '').replace(/\/$/, "");
            },
        },
        methods: {
            companyLink(company) {
                return APP_URL + '/company/' + company.id;
            },
            store() {
                this.submitting = true;
                this.error = false;
                let params = new URLSearchParams();
                params.append('nicename', this.model.site_name);
                params.append('company_id', this.model.company.id);
                params.append('domain', this.model.domain);
                params.append('group', this.model.group);
                params.append('_nonce', this.nonce);
                this.axios.post('/wpremote/api/json/site', params).then((response) => {
                    if (typeof response.data['ID'] === 'undefined') {
                        alert('There was an error doing that');
                        this.submitting = false;
                        return;
                    }
                    if (typeof window.currentCompany !== 'undefined' && this.model.company.id && this.model.company.id === window.currentCompany.id) {
                        this.$eventHub.$emit('remoteTableRefresh');
                        this.$root.viewLoader('/api/remote/' + response.data.ID);
                        this.$eventHub.$emit('removeDialog', this.$parent.name);
                        return;
                    }
                    this.websiteDetails = response.data;
                    this.saved = true;
                    this.wpRemoteInsert(response.data);
//                    window.location = '/remote/' + response.data.ID;
                }).catch((error) => {
                    this.error = error.response.data;
                    this.submitting = false;
                });
                // Need to ensure correct post headers?
//                this.$store('/wpremote/api/json/site', this);
            },
            wpRemoteInsert(data) {
                let mysite = new Site;
                mysite.populateFromObject(data);
                mysite.refresh();
                SitesController.sites.push(mysite);
                sitesListController.selectedSiteId(mysite.id());
//                if ( sitesListController.selectedSiteId() === 0 )
//                    sitesListController.selectedSiteId( data.id() );
            },
        },
        // It's good to clean up event listeners before a component is destroyed.
        beforeDestroy () {
//                this.$eventHub.$off('saving' + this.name, this.savingWebsite);
        }
    }
</script>